import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { loginAdmin } from "../../Services/admin.service.ts";
import styles from "./AdminDashboard.module.css";

const AdminLogin = () => {
  const [form, setForm] = useState({ username: "", password: "" });
  const [error, setError] = useState(() =>
    new URLSearchParams(window.location.search).has("expired")
      ? "Your session ended. Please sign in again."
      : ""
  );
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError("");
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!form.username.trim() || !form.password) {
      setError("Enter your username and password.");
      return;
    }
    setLoading(true);
    const result = await loginAdmin(form.username, form.password);
    setLoading(false);
    if (result.success) {
      dispatch({ type: "LOGIN", payload: { token: result.token, username: result.username } });
      navigate("/admin");
    } else {
      setError(result.error);
    }
  };

  return (
    <div className={styles.loginWrapper}>
      <form onSubmit={handleLogin} className={styles.loginForm}>
        <h4 className={styles.loginTitle}>Admin Login</h4>
        <div className={styles.inputGroup}>
          <input
            type="text"
            name="username"
            placeholder="Username"
            autoComplete="username"
            value={form.username}
            onChange={handleChange}
            className={styles.input}
            autoFocus
          />
        </div>
        <div className={styles.inputGroup}>
          <input
            type="password"
            name="password"
            placeholder="Password"
            autoComplete="current-password"
            value={form.password}
            onChange={handleChange}
            className={styles.input}
          />
        </div>
        {error && <div className={styles.error}>{error}</div>}
        <button type="submit" className={styles.loginButton} disabled={loading}>
          {loading ? "Signing in…" : "Login"}
        </button>
      </form>
    </div>
  );
};

export default AdminLogin;
